import { types } from 'mobx-state-tree';
import Address from '../types/Address';

export default types
  .model('AddressForm', {
    requestInProgress: false,
    wasSuccessful: false,
    wasSubmitted: false,
    error: types.maybeNull(types.string),
    address: types.optional(Address, {}),
  })
  .views(self => ({
    get hasError() {
      return !!self.error;
    },
    get hasAddressError() {
      return !self.address.hasAddress && self.wasSubmitted;
    },
  }))
  .actions(self => ({
    setIsRequesting(state = true) {
      self.requestInProgress = state;
      return self;
    },
    setError(message) {
      self.error = message;
      return self;
    },
    clearError() {
      self.error = null;
      return self;
    },
    setWasSuccessful(wasSuccessful = true) {
      self.wasSuccessful = wasSuccessful;
      return self;
    },
    setWasSubmitted(wasSubmitted = true) {
      self.wasSubmitted = wasSubmitted;
      return self;
    },
  }));
